/**
 * Identity
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CreateUserInternalRequest {
  login?: string | null;
  firstName: string;
  lastName?: string | null;
  middleName?: string | null;
  email?: string | null;
  emailConfirmed?: boolean;
  phoneNumber?: string | null;
  phoneNumberConfirmed?: boolean;
  telegramLogin?: string | null;
  externalId?: string | null;
  isBlocked?: boolean;
  statusId?: number | null;
  userTypeId?: number | null;
  referralCode?: string | null;
  externalSourceId?: number | null;
  isAgreementAcceptanceRequired?: boolean;
  agreementAcceptedDate?: string | null;
  isResetPasswordLinkSendingRequired?: boolean;
  roleIds?: Array<string> | null;
  tenantIds?: Array<string> | null;
}
